import { cva, type VariantProps } from 'class-variance-authority';
import styles from './Icon.module.css';

/*
 * Shared base cva for size variants. Per  P020-A R1 lock:
 * compound categories share one base for common axes (size), extend per-category.
 *
 * Used by Icon.Standard (which has a size axis); Icon.Dot + Icon.Social use the
 * base class for the wrapper shell but not size variants (their dimensions come
 * from the intrinsic SVG).
 */
export const iconBaseVariants = cva(styles.icon, {
  variants: {
    size: {
      sm: styles.sm,
      md: styles.md,
      lg: styles.lg,
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export type IconBaseVariantProps = VariantProps<typeof iconBaseVariants>;
